
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="基本用法" fileName="base.md" />
        <p>1、尝试将 “Number”列的值改为非数字<br>
2、尝试修改第一行第一列</p>
<demo-block>
        <div><p>1、单元格进入编辑状态前首先触发<code>beforeStartCellEditing</code>回调，如果返回 false，则会阻止进入编辑状态。<br>2、单元格停止编辑后首先触发<code>beforeCellValueChange</code>回调，如果返回 false，则会阻止编辑，单元格还原为编辑前状态。编辑成功将触发<code>afterCellValueChange</code>方法<br>3、你可以利用<code>beforeCellValueChange</code>做编辑校验功能<br></p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;ve-table
            rowKeyFieldName=&quot;rowKey&quot;
            :fixed-header=&quot;true&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :editOption=&quot;editOption&quot;
            :rowStyleOption=&quot;rowStyleOption&quot;
            border-y
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // edit option 可控单元格编辑
                editOption: {
                    beforeStartCellEditing: ({ row, column, cellValue }) =&gt; {
                        console.log(&quot;beforeStartCellEditing&quot;);
                        console.log(&quot;row::&quot;, row);
                        console.log(&quot;column::&quot;, column);
                        console.log(&quot;cellValue::&quot;, cellValue);
                        console.log(&quot;---&quot;);

                        if (row.rowKey === 0 &amp;&amp; column.field === &quot;name&quot;) {
                            alert(&quot;You can't edit this cell.&quot;);
                            return false;
                        }
                    },
                    beforeCellValueChange: ({ row, column, changeValue }) =&gt; {
                        console.log(&quot;beforeCellValueChange&quot;);
                        console.log(&quot;row::&quot;, row);
                        console.log(&quot;column::&quot;, column);
                        console.log(&quot;changeValue::&quot;, changeValue);

                        console.log(&quot;---&quot;);

                        if (column.field === &quot;number&quot; &amp;&amp; !/^\d+$/.test(changeValue)) {
                            alert(&quot;请输入数字&quot;);
                            return false;
                        }
                    },
                    afterCellValueChange: ({ row, column, changeValue }) =&gt; {
                        console.log(&quot;afterCellValueChange&quot;);
                        console.log(&quot;row::&quot;, row);
                        console.log(&quot;column::&quot;, column);
                        console.log(&quot;changeValue::&quot;, changeValue);
                        console.log(&quot;---&quot;);
                    },
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;name&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        edit: true,
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;date&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        edit: true,
                    },
                    {
                        field: &quot;number&quot;,
                        key: &quot;number&quot;,
                        title: &quot;Number&quot;,
                        align: &quot;right&quot;,
                        width: &quot;30%&quot;,
                        edit: true,
                    },
                    {
                        field: &quot;address&quot;,
                        key: &quot;address&quot;,
                        title: &quot;Address&quot;,
                        align: &quot;left&quot;,
                        width: &quot;40%&quot;,
                        edit: true,
                    },
                ],
                // table data
                tableData: [
                    {
                        name: &quot;You can't edit&quot;,
                        date: &quot;1900-05-20&quot;,
                        number: &quot;32&quot;,
                        address: &quot;No.1 Century Avenue, Shanghai&quot;,
                        rowKey: 0,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        number: &quot;676&quot;,
                        address: &quot;No.1 Century Avenue, Beijing&quot;,
                        rowKey: 1,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        number: &quot;76&quot;,
                        address: &quot;No.1 Century Avenue, Chongqing&quot;,
                        rowKey: 2,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        number: &quot;7797&quot;,
                        address: &quot;No.1 Century Avenue, Xiamen&quot;,
                        rowKey: 3,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        number: &quot;8978&quot;,
                        address: &quot;No.1 Century Avenue, Shenzhen&quot;,
                        rowKey: 4,
                    },
                ],
            };
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ve-table',{attrs:{"rowKeyFieldName":"rowKey","fixed-header":true,"columns":_vm.columns,"table-data":_vm.tableData,"editOption":_vm.editOption,"rowStyleOption":_vm.rowStyleOption,"border-y":""}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // edit option 可控单元格编辑
                editOption: {
                    beforeStartCellEditing: ({ row, column, cellValue }) => {
                        console.log("beforeStartCellEditing");
                        console.log("row::", row);
                        console.log("column::", column);
                        console.log("cellValue::", cellValue);
                        console.log("---");

                        if (row.rowKey === 0 && column.field === "name") {
                            alert("You can't edit this cell.");
                            return false;
                        }
                    },
                    beforeCellValueChange: ({ row, column, changeValue }) => {
                        console.log("beforeCellValueChange");
                        console.log("row::", row);
                        console.log("column::", column);
                        console.log("changeValue::", changeValue);

                        console.log("---");

                        if (column.field === "number" && !/^\d+$/.test(changeValue)) {
                            alert("请输入数字");
                            return false;
                        }
                    },
                    afterCellValueChange: ({ row, column, changeValue }) => {
                        console.log("afterCellValueChange");
                        console.log("row::", row);
                        console.log("column::", column);
                        console.log("changeValue::", changeValue);
                        console.log("---");
                    },
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 50,
                        align: "center",
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: "name",
                        key: "name",
                        title: "Name",
                        align: "left",
                        width: "15%",
                        edit: true,
                    },
                    {
                        field: "date",
                        key: "date",
                        title: "Date",
                        align: "left",
                        width: "15%",
                        edit: true,
                    },
                    {
                        field: "number",
                        key: "number",
                        title: "Number",
                        align: "right",
                        width: "30%",
                        edit: true,
                    },
                    {
                        field: "address",
                        key: "address",
                        title: "Address",
                        align: "left",
                        width: "40%",
                        edit: true,
                    },
                ],
                // table data
                tableData: [
                    {
                        name: "You can't edit",
                        date: "1900-05-20",
                        number: "32",
                        address: "No.1 Century Avenue, Shanghai",
                        rowKey: 0,
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        number: "676",
                        address: "No.1 Century Avenue, Beijing",
                        rowKey: 1,
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        number: "76",
                        address: "No.1 Century Avenue, Chongqing",
                        rowKey: 2,
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        number: "7797",
                        address: "No.1 Century Avenue, Xiamen",
                        rowKey: 3,
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        number: "8978",
                        address: "No.1 Century Avenue, Shenzhen",
                        rowKey: 4,
                    },
                ],
            };
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  